import { render, staticRenderFns } from "./AggregatorDetail.vue?vue&type=template&id=4ece6069"
import script from "./AggregatorDetail.vue?vue&type=script&lang=js"
export * from "./AggregatorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports